import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';
import { Company } from '../models/company';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api`;


  constructor(private http: HttpClient) {

  }

  login(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http.post(
      this.apiUrl + '/web/login',
      data,
      options
    );
  }



  createNewPassword(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/create-new-password',
      data,
      options
    );
  }

  requestPasswordReset(email: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/request-password-reset',
      {
        email: email,
      },
      options
    );
  }

  enquiry(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post(this.apiUrl + '/web/enquiry', data, options);
  }

  /** Public terminal stats for the login-page HUD (no auth). */
  getTosStats() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.get<any>(this.apiUrl + '/tos/stats', options);
  }

  resetPassword(password: string, token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

      }),
    };

    return this.http.post(
      this.apiUrl + '/web/reset-password',
      {
        token: token,
        password: password,
      },
      options
    );
  }


  logout() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(this.apiUrl + '/token/revoke', options);
  }

  getCurrentCompany() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<any>(this.apiUrl + '/get-current-company', options);
  }


  getUser(token: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }),
    };

    return this.http.get<User>(this.apiUrl + '/user', options);
  }



  requestStudentOneTimePassword(nationalId: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };
    return this.http.post<any>(this.apiUrl + `/web/request-student-otp/${nationalId}`, options);
  }


  saveTokenAndUser(token: any, user: any) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', JSON.stringify(token.token));
    localStorage.setItem('access_token', token.accessToken);
  }

  getCurrentUserFromLocal(): User {
    return new User(JSON.parse(localStorage.getItem('user')!));
  }


  getCurrentCompanyFromLocal(): Company {
    return new Company(JSON.parse(localStorage.getItem('current_company')!));
  }
}
